import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBigQueryIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 8,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8534 35.4493L9.94733 25.2193C9.72025 24.826 9.60071 24.3799 9.60071 23.9257C9.60071 23.4716 9.72025 23.0254 9.94733 22.6321L15.8534 12.4024C16.0805 12.009 16.4072 11.6823 16.8005 11.4553C17.1939 11.2282 17.6401 11.1086 18.0943 11.1086H29.9065C30.3607 11.1087 30.8068 11.2282 31.2002 11.4553C31.5935 11.6824 31.9201 12.009 32.1472 12.4024L38.0533 22.6321C38.2804 23.0255 38.3999 23.4716 38.3999 23.9258C38.3999 24.38 38.2804 24.8262 38.0533 25.2195L32.1472 35.4493C31.9201 35.8426 31.5934 36.1692 31.2001 36.3962C30.8068 36.6233 30.3606 36.7428 29.9065 36.7428H18.0943C17.6401 36.7429 17.1939 36.6233 16.8005 36.3962C16.4071 36.1691 16.0805 35.8427 15.8534 35.4493Z",
			fill: "url(#paint0_linear_16636_7191)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .07,
			d: "M36.4267 28.9837L27.741 20.2976L24.0005 19.2966L20.6407 20.5453L19.3431 23.9259L20.3864 27.6898L29.5972 36.9006L31.5517 36.8137L36.4267 28.9837Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.0003 18.7068C21.1182 18.7068 18.7816 21.0433 18.7816 23.9257C18.7816 26.8079 21.1182 29.1445 24.0003 29.1445C26.8825 29.1445 29.2188 26.8079 29.2188 23.9257C29.2188 21.0433 26.8823 18.7068 24.0003 18.7068ZM24.0003 27.8854C21.8134 27.8854 20.0405 26.1124 20.0405 23.9255C20.0405 21.7386 21.8134 19.9658 24.0003 19.9658C26.1873 19.9658 27.9602 21.7388 27.9602 23.9257C27.9602 26.1127 26.1873 27.8854 24.0003 27.8854Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5234 23.7242V25.3464C21.7635 25.7585 22.1021 26.1044 22.5089 26.3532V23.7242H21.5234ZM23.4775 22.3567V26.724C23.6451 26.7549 23.8166 26.7735 23.9927 26.7735C24.1534 26.7735 24.31 26.7567 24.4636 26.731V22.3567H23.4775ZM25.5229 24.3983V26.3247C25.9362 26.0619 26.2756 25.6979 26.5088 25.2672V24.3985L25.5229 24.3983ZM27.756 27.1403L27.2153 27.6814C27.1695 27.7273 27.1438 27.7895 27.1438 27.8543C27.1438 27.9191 27.1695 27.9813 27.2153 28.0272L29.2661 30.0773C29.312 30.1231 29.3742 30.1488 29.439 30.1488C29.5039 30.1488 29.5661 30.1231 29.6119 30.0773L30.1526 29.5369C30.1981 29.4909 30.2236 29.4288 30.2236 29.3641C30.2236 29.2994 30.1981 29.2373 30.1526 29.1913L28.1016 27.1403C28.0556 27.0947 27.9935 27.0691 27.9288 27.0691C27.864 27.0691 27.8019 27.0947 27.756 27.1403Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_16636_7191",
			x1: 24.0004,
			y1: 11.1089,
			x2: 24.0004,
			y2: 36.703,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#4387FD" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#4683EA"
			})]
		}) })
	]
});
export default SvgBigQueryIcon;
